import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import classnames from "classnames";

const styles = theme => ({
  root: {
    margin: "0 auto"
  },
  ButtonStyles: {
    color: "#F37020"
  }
});

class CustomSnackBar extends Component {
  constructor(props) {
    super(props);
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.props.handleClose();
  };

  render() {
    const { classes, message, buttonText } = this.props;
    const { root, ButtonStyles } = classes;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        open={this.props.open}
        onClose={this.handleClose}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{message}</span>}
        action={[
          <Button
            key="undo"
            className={ButtonStyles}
            size="small"
            onClick={this.props.handleClick}
          >
            {buttonText}
          </Button>,
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={this.props.handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    );
  }
}

export default withStyles(styles)(CustomSnackBar);



// WEBPACK FOOTER //
// ./src/components/Utils/CustomSnackBar.js